var map = {
	"./academic.js": "ef0f",
	"./check-status.js": "38d6",
	"./exam.js": "194d",
	"./index.js": "c72f",
	"./list.js": "8437",
	"./payment.js": "9a47",
	"./sellersReporting.js": "bf72",
	"./student.js": "fd50",
	"./user.js": "47ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1e5";